import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "skip-links-inner visually-hidden-focusable" }
const _hoisted_2 = ["href"]

import { inject } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SkipLink',
  props: {
    to: {}
  },
  setup(__props: any) {

const props = __props;

const i18n = inject('i18n') as { [key: string]: string };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: props.to
    }, _toDisplayString(_unref(i18n).skipNavigation), 9 /* TEXT, PROPS */, _hoisted_2)
  ]))
}
}

})